import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class SystemTranslationInstructionVideoStatisticService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      summary: 0,
      fetching: false,
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/instruction-videos/total',
      })
      .then(() => {
        if (this.fetch.data) {
          this.summary = this.fetch.data.total;
        }
        if (this.fetch.error) {
          this.summary = 0;
        }
      });
  });
}

export default SystemTranslationInstructionVideoStatisticService;
